import { useReduxSelector } from '../../../hooks';
import { rootStateBranchSelector } from '../../../utils/rootStateBranchSelector';
import type { JsonQueryInitialState } from '../slice';

export const jsonQuerySelector = rootStateBranchSelector('jsonQuery');

export function useJsonQuerySelector(): JsonQueryInitialState {
  return useReduxSelector(jsonQuerySelector);
}
